import { Box, Container, Stack, Button } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { retrieveNewDishes } from "./selector";
import { Product } from "../../../lib/types/product";
import React, { useState } from "react";
import { serverApi } from "../../../lib/config";
import { useGlobals } from "../../hooks/useGlobal";
import ReviewModal from "../../components/review/ReviewModal";
import { Messages } from "../../../lib/config";
import { sweetErrorHandling } from "../../../lib/sweetAlert";
import { useHistory } from "react-router-dom";

const newDishesRetriever = createSelector(retrieveNewDishes, (newDishes) => ({
  newDishes,
}));

function formatSizeLabel(format?: string) {
  if (!format || format === "STANDARD") return "STANDART size";
  return `${format} size`;
}

export default function NewDishes() {
  const { newDishes } = useSelector(newDishesRetriever);
  const { authMember } = useGlobals();
  const [reviewProduct, setReviewProduct] = useState<Product | null>(null);
  const history = useHistory();

  const openReview = (e: React.MouseEvent, product: Product) => {
    e.stopPropagation();
    if (!authMember) {
      sweetErrorHandling(Messages.error2);
      return;
    }
    setReviewProduct(product);
  };

  return (
    <div className={"new-products-frame"}>
      <Container>
        <Stack className={"main"}>
          <Box className={"category-title"}>New Arrivals</Box>
          <Stack className={"cards-frame"}>
            {newDishes.length !== 0 ? (
              newDishes.map((product: Product) => {
                const imagePath = `${serverApi}/${product.productImages[0]}`;
                return (
                  <Box
                    key={product._id}
                    className="arrival-card"
                    onClick={() => history.push(`/products/${product._id}`)}
                  >
                    <Box
                      className="arrival-cover"
                      sx={{ backgroundImage: `url(${imagePath})` }}
                    >
                      <div className="arrival-badge">
                        {formatSizeLabel(product.productFormat)}
                      </div>
                      <div className="arrival-hover">
                        <span className="arrival-hover-author">
                          {product.productAuthor || "Author"}
                        </span>
                        <Button
                          className="write-review-btn"
                          variant="outlined"
                          startIcon={<ChatBubbleOutlineIcon />}
                          onClick={(e) => openReview(e, product)}
                        >
                          Write a Review
                        </Button>
                      </div>
                    </Box>
                    <Box className="arrival-body">
                      <strong className="arrival-title">{product.productName}</strong>
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        className="arrival-meta"
                      >
                        <span className="arrival-price">${product.productPrice}</span>
                        <span className="arrival-views">
                          <VisibilityIcon sx={{ fontSize: 16 }} />
                          {product.productViews}
                        </span>
                      </Stack>
                    </Box>
                  </Box>
                );
              })
            ) : (
              <Box className="no-data">New books are not available!</Box>
            )}
          </Stack>
        </Stack>
      </Container>
      <ReviewModal
        open={!!reviewProduct}
        product={reviewProduct}
        onClose={() => setReviewProduct(null)}
      />
    </div>
  );
}
